import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import { ExtraCatalogResponse, ExtraType } from "../../../api";
import { ListSubheader } from "@material-ui/core";
import _ from "lodash";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import classNames from "classnames";

interface ExtraCatalogProps extends WithStyles<typeof styles> {
  disabled: boolean;
  chosenTypes: string[];
  extraTypes: ExtraCatalogResponse[]
  onChange: (value: string[]) => void;
}

const styles = (theme: Theme) => createStyles({
  formControl: {
    width: '100%',
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important'
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important'
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important'
    },
    '& .MuiSelect-select': {
      height: '20px',
      boxSizing: 'border-box',
      lineHeight: '20px',
      padding: '0',
      paddingRight: '20px'
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: '#fff'
    },
    '& .MuiSelect-icon': {
      marginRight: '16px'
    }
  },
  select: {
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '8px 12px',
    '&:focus': {
      borderRadius: '4px',
      backgroundColor: '#fff',
    },
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  timeFields: {
    width: 80,
  },
  menuItem: {
    paddingTop: '8px',
    paddingBottom: '8px',
    '&.Mui-selected': {
      color: '#6AE8C5',
    },
    '&.Mui-selected:hover': {
      color: '#6AE8C5',
    }
  },
  subheadTitle: {
    backgroundColor: '#fff'
  },
  wishesContainer: {
    marginTop: '16px'
  },
});

function ExtraCatalog(props: ExtraCatalogProps) {
  const { classes, disabled, chosenTypes, extraTypes, onChange } = props;
  const [value, setValue] = useState(props.chosenTypes || []);
  const prevValue = useRef(value);

  useEffect(() => {
    setValue(chosenTypes)
  }, [chosenTypes])

  const getExtraList = useMemo(() => {
    let ExtraList = ''
    if (extraTypes && chosenTypes) {
      chosenTypes.forEach(function (chosenType) {
        extraTypes.forEach((extraType) => {
          const type = extraType.extras.find(extra => extra.type === chosenType)
          if (type) {
            ExtraList += ExtraList.length > 0 ? `, ` : ''
            ExtraList += type.name
          }
        })
      });
    }
    return ExtraList
  }, [value, extraTypes])

  const handleClose = () => {
    if (!_.isEqual(_.sortBy(value), _.sortBy(prevValue.current))) {
      onChange(value)
      prevValue.current = value;
    }
  };

  const handleOpen = () => {
    prevValue.current = value;
  };

  const handleChange = (event: any) => {
    setValue(event.target.value);
  }

  return (
    <div className={classes.wishesContainer}>
      <span style={disabled ? { color: 'rgba(10, 25, 35, 0.4)' } : { color: 'rgba(10, 25, 35, 0.9)' }}>Особенности (необязательно)</span>
      <FormControl className={classes.formControl}>
        <Select
          multiple
          disabled={disabled}
          className={classes.select}
          value={value}
          onOpen={handleOpen}
          renderValue={() => (
            <div style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '20px',
            }}>
              {getExtraList}
            </div>
          )}
          IconComponent={(props) =>
            props.open ? <ExpandLess {...props} /> : <ExpandMore {...props} />
          }
          onClose={handleClose}
          onChange={handleChange}
        >
          {
            extraTypes && extraTypes.length > 0 && extraTypes.map((extraItem: ExtraCatalogResponse) => [
                <ListSubheader className={classes.subheadTitle}>{extraItem.name}</ListSubheader>,
                extraItem.extras.map((item: ExtraType) => (
                  <MenuItem
                    key={item.type}
                    value={item.type}
                    className={classNames(classes.menuItem, {
                      'Mui-selected': value.includes(item.type)
                    })}
                  >
                    {item.name}
                  </MenuItem>
                ))
              ]
            )
          }
        </Select>
      </FormControl>
    </div>
  );
}

export default withStyles(styles, { withTheme: true })(ExtraCatalog);